export default "__VITE_ASSET__B8RJ7oGN__"